import { render, staticRenderFns } from "./triggerRules.vue?vue&type=template&id=c48e8092&scoped=true&"
import script from "./triggerRules.vue?vue&type=script&lang=ts&"
export * from "./triggerRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48e8092",
  null
  
)

export default component.exports